if (!customElements.get('ly-learn-more-expandable-tab-section')) {
    customElements.define('ly-learn-more-expandable-tab-section', class extends HTMLElement {

        itemToInput = new WeakMap()
        checkedInput = null

        connectedCallback() {
            this.init()

            this.addEventListener('change', this.handleChange)

            requestAnimationFrame(() => {
                this.handleChange()
            })
        }

        disconnectedCallback() {
            this.removeEventListener('change', this.handleChange)
        }

        init = () => {
            this.items = [...this.querySelectorAll('[data-item]')]
            this.items.forEach(item => {
                const input = item.querySelector('input')
                this.itemToInput.set(item, input)
            })
            this.blocks = [...this.querySelectorAll('[data-block]')]
        }

        handleChange = () => {
            this.items.forEach(item => {
                const input = this.itemToInput.get(item)
                if (input.checked) {
                    this.checkedInput = input
                }
                item.classList.toggle('is-open', input.checked)
            })
            if (!this.checkedInput) return
            this.blocks.forEach(block => {
                block.classList.toggle('is-active', block.dataset.block === this.checkedInput.value)
            })
        }
    })
}